import pinyin from 'pinyin';

/**
 * 取姓名首字的拼音首字母（大写 A–Z），非汉字/拼不出归入 '#'。
 * 「行」固定映射为 X（沿用社区页原逻辑，配合行字辈弟子命名）。
 */
export const getPinyinInitial = (name) => {
  if (!name) return '#';
  try {
    const firstChar = name[0];
    if (firstChar === '行') return 'X';
    const py = pinyin(firstChar, { style: pinyin.STYLE_FIRST_LETTER });
    const initial = py[0][0].toUpperCase();
    return /[A-Z]/.test(initial) ? initial : '#';
  } catch {
    return '#';
  }
};

/** 全名拼音（小写、无分隔），用于姓名拼音排序的二级比较键。 */
export const getPinyinFull = (name) => {
  if (!name) return '';
  try {
    return pinyin(name, { style: pinyin.STYLE_NORMAL, heteronym: false })
      .map((a) => a[0])
      .join('');
  } catch {
    return String(name);
  }
};

/** 按拼音（首字母 → 全名拼音 → 原字符串）升序比较两个姓名。 */
export const comparePinyin = (a, b) => {
  const ia = getPinyinInitial(a);
  const ib = getPinyinInitial(b);
  if (ia !== ib) return ia.localeCompare(ib);
  return getPinyinFull(a).localeCompare(getPinyinFull(b)) || String(a).localeCompare(String(b));
};
